export const getTheme = state => state.theme.mode;
